import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useDisclosure,
  Button,
  useToast,
  Input,
  Text,
  Switch,
  Tooltip,
} from '@chakra-ui/react';
import OperationLocationApi from 'api/operationlocation';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Location name is required'),
  displayOrder: Yup.number()
    .positive('Display order must be positive')
    .integer('Display order must be an integer')
    .required('Display order is required'),
});

export default function PopModal({
  initialData,
  head,
  Icon,
  func,
  handleUpdate,
  id,
  error,
  emailError,
  disabled,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [isactive, setisactive] = useState(initialData.is_active);
  const toast = useToast();
  console.log('function ', handleUpdate);
  const formik = useFormik({
    initialValues: {
      name: initialData.name || '',
      displayOrder: initialData.display_order || '',
      isActive: initialData.is_active || false,
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const apiResponse = await OperationLocationApi.Update({
          id: initialData.id,
          name: values.name,
          display_order: Number(values.displayOrder),
          is_active: isactive,
        });

        if (apiResponse.data.status_code === 200) {
          toast({
            title: 'Successfully Updated',
            description: apiResponse.data.message,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top',
          });
          onClose();
          handleUpdate();
          resetForm();
        } else {
          throw new Error(apiResponse.data.message);
        }
      } catch (error) {
        console.log('Error', error);
        toast({
          title: 'Failed to update Location',
          description: error.response?.data?.message || 'Unknown error',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (isOpen) {
      formik.setValues({
        name: initialData.name,
        displayOrder: initialData.display_order,
        isActive: initialData.is_active,
      });
    }
  }, [initialData, isOpen]);

  return (
    <>
      <Button onClick={onOpen} disabled={disabled}>
        {Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={formik.handleSubmit}>
            <ModalHeader>{head}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl
                isInvalid={formik.touched.subject && formik.errors.subject}
              >
                <FormLabel>Location Name *</FormLabel>
                <Input
                  variant='auth'
                  placeholder='Enter Location Name'
                  ref={initialRef}
                  {...formik.getFieldProps('name')}
                />
                {formik.touched.name && formik.errors.name ? (
                  <Text color='red.400'>{formik.errors.name}</Text>
                ) : null}
              </FormControl>

              <FormControl
                mt={4}
                isInvalid={
                  formik.touched.displayOrder && formik.errors.displayOrder
                }
              >
                <FormLabel>Display Order *</FormLabel>
                <Input
                  variant='auth'
                  type='number'
                  placeholder='Enter Display Order'
                  {...formik.getFieldProps('displayOrder')}
                />
                {formik.touched.displayOrder && formik.errors.displayOrder ? (
                  <Text color='red.400'>{formik.errors.displayOrder}</Text>
                ) : null}
              </FormControl>

              <FormControl display='flex' alignItems='center' mt={4}>
                <FormLabel htmlFor='email-alerts' mb='0'>
                  Is Active?
                </FormLabel>
                <Switch
                  id='active-filter'
                  value={isactive}
                  defaultChecked={initialData.is_active}
                  onChange={(e) => setisactive(e.target.checked)}
                />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme='blue'
                mr={3}
                type='submit'
                disabled={formik.isSubmitting || !formik.isValid}
                // onClick={() => {
                //   handleUpdate(onClose, id);
                // }}
                // disabled={error || emailError ? true : false}
              >
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
